type Props = React.OptionHTMLAttributes<HTMLOptionElement> & {
  label?: string
  value: string
}

export const SelectOption: React.FC<Props> = ({ label, value, ...props }) => {
  return (
    <option value={value} {...props}>
      {label ?? value}
    </option>
  )
}
